import type Size from "@/util/Size.ts";
import type {MapTransform} from "@/encounter/model/ViewPort.ts";
import type {FogScene} from "./SoftFogWorkerProtocol.ts";

export type FogPlacement = {x: number; y: number; width: number; height: number};
export type FogCover = {x: number; y: number; width: number; height: number};

export function placeFogFrame(scene: FogScene, transform: MapTransform): FogPlacement {
    const ratio = transform.scale / scene.transform.scale;
    return {
        x: transform.x - scene.transform.x * ratio,
        y: transform.y - scene.transform.y * ratio,
        width: scene.stageSize.width * ratio,
        height: scene.stageSize.height * ratio,
    };
}

export function fogPlacementInWorld(placement: FogPlacement, transform: MapTransform): FogPlacement {
    return {
        x: (placement.x - transform.x) / transform.scale,
        y: (placement.y - transform.y) / transform.scale,
        width: placement.width / transform.scale,
        height: placement.height / transform.scale,
    };
}

export function uncoveredFogRegions(size: Size, image: FogPlacement | undefined): FogCover[] {
    if (!image) return [{x: 0, y: 0, width: size.width, height: size.height}];
    const left = Math.max(0, Math.min(size.width, image.x));
    const right = Math.max(0, Math.min(size.width, image.x + image.width));
    const top = Math.max(0, Math.min(size.height, image.y));
    const bottom = Math.max(0, Math.min(size.height, image.y + image.height));
    if (right <= left || bottom <= top) {
        return [{x: 0, y: 0, width: size.width, height: size.height}];
    }
    return [
        {x: 0, y: 0, width: left, height: size.height},
        {x: right, y: 0, width: size.width - right, height: size.height},
        {x: left, y: 0, width: right - left, height: top},
        {x: left, y: bottom, width: right - left, height: size.height - bottom},
    ].filter(region => region.width > 0 && region.height > 0);
}
